import { useEffect, useRef, useState } from "react";
import { AutoSizer } from "react-virtualized";
import { GIF_MASONRY_GAPS } from "../../constants";
import { useGifsStoreShallow } from "../../store";
import { GifsMasonryColumn } from "./gifs-masonry-column";

const GAPS = GIF_MASONRY_GAPS;

interface IProps {
  searchQuery: string;
  loadMoreGifs: () => void;
}

export const ImagesPanelGifsMasonry = ({
  searchQuery,
  loadMoreGifs,
}: IProps) => {
  const columnsData = useGifsStoreShallow((s) => s.columnsData);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    const containerEl = containerRef.current;
    if (!containerEl) return;
  }, [searchQuery]);

  return (
    <div
      ref={containerRef}
      className="scrollbar tw-mt-3 tw-w-[calc(100%-6px)] tw-overflow-y-scroll tw-overscroll-contain tw-pb-6 tw-pl-6 tw-pr-3 tw-pt-1"
      onScroll={(e) => {
        setScrollTop(e.currentTarget.scrollTop);
      }}
    >
      <AutoSizer>
        {({ width, height }) => (
          <div
            className="tw-grid tw-grid-flow-col tw-content-start"
            style={{ width, columnGap: GAPS }}
          >
            {columnsData.map((col, colIdx) => (
              <GifsMasonryColumn
                key={colIdx}
                onLoadMore={colIdx === 0 ? loadMoreGifs : undefined}
                colIdx={colIdx}
                gifs={col}
                scrollTop={scrollTop}
                colWidth={
                  (width - GAPS * (columnsData.length - 1)) / columnsData.length
                }
                height={height}
              />
            ))}
          </div>
        )}
      </AutoSizer>
    </div>
  );
};
